module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookNavigation",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.addOutline()
      }
    }
  }, [_c('span', {
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: (!_vm.atFirstPage),
      expression: "!atFirstPage"
    }],
    staticClass: "icon",
    class: {
      outlined: _vm.isOutlined
    },
    style: (_vm.iconStyles),
    attrs: {
      "role": "button",
      "tabindex": !_vm.atFirstPage ? 0 : -1,
      "aria-label": "previous page"
    },
    on: {
      "click": function($event) {
        return _vm.turnLeftPage()
      },
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.turnLeftPage()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.addOutline()
      }]
    }
  }, [_c('arrow-left-svg')], 1), _vm._v(" "), (!_vm.audioPlaying) ? _c('span', {
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: (_vm.hasAudioSource),
      expression: "hasAudioSource"
    }],
    staticClass: "icon",
    class: {
      outlined: _vm.isOutlined
    },
    style: (_vm.iconStyles),
    attrs: {
      "role": "button",
      "tabindex": _vm.hasAudioSource && !_vm.audioPlaying ? 0 : -1,
      "aria-label": "play audio"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAudio()
      },
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toggleAudio()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.addOutline()
      }]
    }
  }, [_c('volume-up-svg')], 1) : _vm._e(), _vm._v(" "), (_vm.audioPlaying) ? _c('span', {
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: (_vm.hasAudioSource),
      expression: "hasAudioSource"
    }],
    staticClass: "icon",
    class: {
      outlined: _vm.isOutlined
    },
    style: (_vm.iconStyles),
    attrs: {
      "role": "button",
      "tabindex": _vm.hasAudioSource && _vm.audioPlaying ? 0 : -1,
      "aria-label": "stop audio"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAudio()
      },
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toggleAudio()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.addOutline()
      }]
    }
  }, [_c('volume-mute-svg')], 1) : _vm._e(), _vm._v(" "), (!_vm.atEndPage) ? _c('span', {
    staticClass: "icon visible",
    class: {
      outlined: _vm.isOutlined
    },
    style: (_vm.iconStyles),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": "next page"
    },
    on: {
      "click": function($event) {
        return _vm.turnRightPage()
      },
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.turnRightPage()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.addOutline()
      }]
    }
  }, [_c('arrow-right-svg')], 1) : _c('span', {
    staticClass: "icon visible",
    class: {
      outlined: _vm.isOutlined
    },
    style: (_vm.iconStyles),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": "go home"
    },
    on: {
      "click": function($event) {
        return _vm.goToHomePage()
      },
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.goToHomePage()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.addOutline()
      }]
    }
  }, [_c('home-svg')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bab3c8d0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-book-component/components/bookNavigation/bookNavigation.vue
// module id = 37
// module chunks = 0